import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { getFetch, postFetch } from "config/fetch";
import { baseURL } from "constants/baseUrl";
import * as queryKeys from "utils/queryKeys";
import { generateUrlSearchString } from "./utils/generateUrlSearchString";

export const useGetTransactionsQuery = (params = {}) => {
  const searchParams = generateUrlSearchString(params);

  return useQuery({
    queryFn: () => getFetch(`${baseURL}/transactions?${searchParams}`),
    queryKey: [queryKeys.transactions, { searchParams }],
    select: (data) => data?.data,
  });
};

export const useGetTransactionDetailsQuery = (transactionId) =>
  useQuery({
    queryFn: () => getFetch(`${baseURL}/transactions/${transactionId}`),
    queryKey: [queryKeys.transactionDetails, { transactionId }],
    select: (data) => data?.data,
    enabled: !!transactionId,
  });

export const useGetPendingTransactionsQuery = (params = {}) => {
  const searchParams = generateUrlSearchString(params);
  return useQuery({
    queryFn: () => getFetch(`${baseURL}/transactions/details?${searchParams}`),
    queryKey: [queryKeys.transactions, { searchParams }],
    select: (data) => data?.data.transactionDetails,
  });
};

export const useApproveTransactionMutation = (options) => {
  const query = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      postFetch(`${baseURL}/transactions/approve`, "POST", {}, data),
    onSuccess: () => {
      query.invalidateQueries({ queryKey: [queryKeys.transactions] });
    },
    ...options,
  });
};
